'use client'
import React, { createContext, useContext, useState } from 'react'

interface Theme {
  color: string
  darkMode: string
}

interface LayoutState {
  theme: Theme
  globalSettings?: any
  pageData?: any
  setGlobalSettings?: React.Dispatch<React.SetStateAction<any>>
  setPageData?: React.Dispatch<React.SetStateAction<any>>
}

const defaultTheme = {
  color: 'blue',
  darkMode: 'default',
}

const LayoutContext = createContext<LayoutState>({
  theme: defaultTheme,
})

export const useLayout = () => {
  const context = useContext(LayoutContext)
  if (!context) {
    return {
      theme: defaultTheme,
      globalSettings: undefined,
      pageData: undefined,
    }
  }
  return context
}

interface LayoutProviderProps {
  children: React.ReactNode
  globalSettings?: any
  pageData?: any
}

export const LayoutProvider: React.FC<LayoutProviderProps> = ({
  children,
  globalSettings: initialGlobalSettings,
  pageData: initialPageData,
}) => {
  const [globalSettings, setGlobalSettings] = useState(initialGlobalSettings)
  const [pageData, setPageData] = useState(initialPageData)

  const theme = globalSettings?.theme || defaultTheme

  return (
    <LayoutContext.Provider
      value={{
        globalSettings,
        setGlobalSettings,
        pageData,
        setPageData,
        theme,
      }}
    >
      {children}
    </LayoutContext.Provider>
  )
}
